import { CaregiverCallConfirmationType } from '@/shared/call/CaregiverCallConfirmationType';
import { fetch } from '@/shared/fetch';

import { ConfirmationDto } from '../model/ConfirmationDto';

type FetchConfirmationDataProps = {
    consultationUid: string;
    type: CaregiverCallConfirmationType;
};

export const fetchConfirmationData = async ({
    consultationUid,
    type,
}: FetchConfirmationDataProps): Promise<ConfirmationDto> => {
    const url = `/api/caregivers/consultation-call-confirmation?consultationUid=${consultationUid}&confirmationType=${type}`;
    return fetch<ConfirmationDto>(url);
};
